import loadable from '@loadable/component';

export const OrgDashboardCreditsLinksPageLoadable = loadable(
  () => import('./OrgDashboardCreditsLinksPage'),
  { resolveComponent: (module) => module.OrgDashboardCreditsLinksPage },
);
